<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<p-datePicker
  [readonlyInput]="true"
  placeholder="{{ placeholder }}"
  appendTo="body"
  dateFormat="yy-mm-dd"
  dataType="string"
  [style]="style"
  [name]="name"
  [showClear]="showClear"
  [showButtonBar]="true"
  [ngModel]="displayValue"
  (onSelect)="onFilter.emit(getDateString($event))"
  (onClear)="onFilter.emit(null)"
  (onClearClick)="onFilter.emit(null)" data-testid="value-datepicker">
</p-datePicker>


